import React from 'react';
import { useDispatch } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { isUndefined, isNull } from 'lodash';

import { useCurrentUser } from '@components/Auth';
import { Loading, LoadingError } from '@components/Base';
import { RightCol } from '@components/HealthQuoteBuyRoute/right-col';
import HealthQuoteBuyForm, { FormValues, FormValuesForCreate } from '@components/HealthQuoteBuyRoute/HealthQuoteBuyForm';

import { cancerQuoteCreate, CancerQuoteCreatePayload } from '../action';
import { useCancerQuoteFind } from '../hook';
import { useInitialValues } from './hook';

const CancerQuoteBuyNewPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  useCurrentUser();
  const cancerQuote = useCancerQuoteFind();
  const initialValues = useInitialValues();

  if (isUndefined(cancerQuote)) return <Loading />;
  if (isNull(cancerQuote)) return <LoadingError />;
  if (!initialValues) return null;

  const { cancerPlanQuestions, occupationDeclarationDescription } = cancerQuote;

  const handleSubmit = ({ isConfirmedDeclaration, ...rest }: FormValues) => {
    const payload: CancerQuoteCreatePayload = ({ ...rest, cancerPlanId: (rest as FormValuesForCreate).planId }) as CancerQuoteCreatePayload;
    dispatch(cancerQuoteCreate(payload));
  };

  return (
    <Container className="my-5">
      <Row>
        <h2>{t('cancerQuoteBuyPage.title')}</h2>
        <p>{t('cancerQuoteBuyPage.subTitle')}</p>
        <Col lg={8}>
          <HealthQuoteBuyForm
            initialValues={initialValues}
            onSubmit={handleSubmit}
            questions={cancerPlanQuestions}
            description={occupationDeclarationDescription} />
        </Col>

        <RightCol {...cancerQuote} planName={cancerQuote.cancerPlanName} />
      </Row>
    </Container>
  );
};

export { CancerQuoteBuyNewPage };
